(function(window, document, $) {
    "use strict";
    var youtubeEmbedHandler = {
        init: function() {
            this.bindEvents();
        },

        bindEvents: function () {
            var $videos = $('iframe[src*="youtube.com"]');
            $videos.each(function (i, video) {
                var url = $(video).attr('src');
                if (url) {
                    url += (url.indexOf('?') > -1 ? '&' : '?') + 'rel=0';
                    $(video).attr('src', url);
                }
            });
        }
    };
    youtubeEmbedHandler.init();
})(window, document, jQuery);